import classNames from 'classnames';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import StylishNewTextArea from '../../DesignSystems/New/StylishNewTextArea';

type FormTextAreaFieldProps = {
  title: string;
  fieldName: string;
  rules?: { [key: string]: { value: unknown; message: string } };
  defaultValue?: string;
  variant?: 'full' | 'half';
  disabled?: boolean;
  placeholder?: string;
};

const FormTextAreaField: React.FC<FormTextAreaFieldProps> = ({
  title,
  fieldName,
  rules,
  defaultValue,
  variant = 'full',
  disabled = false,
  placeholder,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const required = typeof rules?.required === 'object' && rules.required.value;
  const inputId = `${fieldName}-textarea`;

  return (
    <div
      className={classNames('mt-2', {
        'col-6': variant === 'half',
        'col-12': variant === 'full',
      })}
    >
      <label className="form-label" htmlFor={inputId}>
        {title}
        {required ? (
          <span aria-label="Required field" className="required">
            *
          </span>
        ) : null}
      </label>
      <StylishNewTextArea
        id={inputId}
        defaultValue={defaultValue}
        placeholder={placeholder}
        {...register(fieldName, rules)}
        disabled={disabled}
      />
      {errors[fieldName] ? (
        <div className="form-text form-error">
          {errors[fieldName].message as string}
        </div>
      ) : (
        <div className="form-text-none"></div>
      )}
    </div>
  );
};
export default FormTextAreaField;
